import * as React from 'react';
import merge from 'lodash/merge';
import { css } from 'styled-components';

import Box from '../Layout/Box';
import { cssDeclaration, VALID_DIMENSION_DATA, VALID_EDGE_STYLE_DATA } from '../Utils';
import { LoadingSpinner } from '../Spinner/LoadingSpinner';
import { media } from '../../../lib/StyledComponents/StyledComponents';

import { ThemedButton } from './StyledButton';

interface ILoadingWrapperProps {
  isLoading?: boolean;
  margin?: VALID_EDGE_STYLE_DATA;
  variant: string;
  width?: VALID_DIMENSION_DATA;
}

const loadingWrapperTheme = {
  box: {
    direction: { base: 'column', medium: 'row' },
  },
  children: {
    margin: {
      base: { top: '2x' },
      medium: { left: '2x', top: 'none' }
    },
  }
};

const LoadingWrapper: React.FC<ILoadingWrapperProps> = ({ children, isLoading, variant, margin, width }) => {
  const Wrapper = isLoading ? Box : React.Fragment;

  return (
    <Wrapper
      {...isLoading && merge(
        loadingWrapperTheme.box,
        { margin },
        { childrenStyles: css`
          ${({ theme: { themeTwo }}) => {
            const { button } = themeTwo;
            const buttonDefault = button.base;
            const variantBase = button.overrides[variant].base;
            const variantTheme = merge({}, buttonDefault, variantBase);
            const widthOverride = width ? cssDeclaration(themeTwo, 'width', width) : undefined;

            if (variantTheme.loadingIconInsideButton) {
              const loadingSpinnerStyles = variantTheme.spinner;

              return css`
                width: 100%;
                ${widthOverride};

                & > ${ThemedButton} > span > ${LoadingSpinner} {
                  #loading-circle-outline {
                    /* stroke */
                    ${loadingSpinnerStyles.color.circleOutline &&
                      cssDeclaration(themeTwo, 'stroke', loadingSpinnerStyles.color.circleOutline)
                    };
                  }

                  ${themeTwo.spinner.withOutline ? css`
                    #animation-outline {
                      /* stroke */
                      ${loadingSpinnerStyles.color.animatedOutline &&
                        cssDeclaration(themeTwo, 'stroke', loadingSpinnerStyles.color.animatedOutline)
                      };
                    }
                  ` : css`
                      stroke: transparent;
                  `}
                }
              `;
            } else {
              return css`
                width: 100%;
                position: relative;
                ${widthOverride};

                & > ${ThemedButton} + ${LoadingSpinner} {
                  position: absolute;
                  align-self: center;
                  top: 100%;
                  /* margin */ ${cssDeclaration(themeTwo, 'margin', loadingWrapperTheme.children.margin)};

                  ${media.medium`
                    top: auto;
                    left: 100%;
                  `}
                }
              `;
            }
          }}
        `}
      )}
    >
      {children}
    </Wrapper>
  );
};

export default LoadingWrapper;
